import React, {useState} from 'react'
import {CiCircleChevRight, CiCircleChevLeft} from 'react-icons/ci'
import { TbCircleX } from 'react-icons/tb'
import { GalleryH1, SliderWrap, BtnClose, BtnPrev, BtnNext,FullScreenImage, FSImage, SingleImage, GalleryWrap, Single, GalleryContainer } from './GalleryElements'



const Gallery = ({galleryImages}) => {

    const [slideNumber, setSlideNumber] = useState(0)
    const [openModal, setOpenModal] = useState(false)
  
    const handleOpenModal = (index) => {
      setSlideNumber(index)
      setOpenModal(true)
    }

  
    // Close Modal
    const handleCloseModal = () => {
      setOpenModal(false)
    }
  
    // Previous Image
    const prevSlide = () => {
      slideNumber === 0 
      ? setSlideNumber( galleryImages.length -1 ) 
      : setSlideNumber( slideNumber - 1 )
    }
  
    // Next Image  
    const nextSlide = () => {
      slideNumber + 1 === galleryImages.length 
      ? setSlideNumber(0) 
      : setSlideNumber(slideNumber + 1)
    }
  

  return (
    <GalleryContainer id={'gallery'}>
      <GalleryH1 className='font-family-Mont'>gallery</GalleryH1>
        {openModal &&
            <SliderWrap> 
                <BtnClose onClick={handleCloseModal}><TbCircleX /></BtnClose>
                <BtnPrev onClick={prevSlide}><CiCircleChevLeft /></BtnPrev>
                <BtnNext onClick={nextSlide}><CiCircleChevRight /></BtnNext>
                <FullScreenImage >
                    <FSImage src={galleryImages[slideNumber].img} alt=''/>
                </FullScreenImage>
            </SliderWrap>
        }
        <GalleryWrap  >
            {
                galleryImages && galleryImages.map((slide, index) => {
                    return(
                        <Single key={index}
                        onClick={ () => handleOpenModal(index) }>
                            <SingleImage src={slide.img} alt='' />
                        </Single>
                    )
                })
            }
        </GalleryWrap>
    </GalleryContainer>
  )
}

export default Gallery
